import React, { useState, useEffect, useCallback } from "react";
import { Col, Row, Pagination, Collapse, Button, Modal, message } from "antd";
import axios from "axios";
import { CaretRightOutlined, DownloadOutlined } from "@ant-design/icons";

import PageHeader from "../Layout/PageHeader";
import PayoutList from "./PayoutList";
import PayoutFilters from "./PayoutFilters";

import RemittanceButton from "./RemittanceButton";
const Payout = () => {
  const [loading, setLoading] = useState({ index: false });
  const [isDownloading, setIsDownloading] = useState(false);
  const [payouts, setPayouts] = useState();
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 50 });
  const [selectedRows, setSelectedRows] = useState([]);

  const fetchPayouts = useCallback(async () => {
    setLoading((prevLoading) => ({ ...prevLoading, index: true }));

    const params = {
      limit: pagination.limit,
      page: pagination.currentPage,
      ...(filters.search && {
        searchField: filters.searchField,
        search: filters.search,
      }),
      ...(filters.isSuccess !== null && { isSuccess: filters.isSuccess }),
      ...(filters.paymentProvider !== null && { paymentProvider: filters.paymentProvider }),
      ...(filters.status !== null && { status: filters.status }),
      ...(filters.payoutType !== null && { payoutType: filters.payoutType }),
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
    };
    const res = await axios.get("/api/payout", { params });

    setPayouts(res.data.data || []);
    setPagination(res.data.pagination);
    setLoading((prevLoading) => ({ ...prevLoading, index: false }));
  }, [pagination.currentPage, pagination.limit, filters]);

  const downloadCSV = async () => {
    setIsDownloading(true);

    const messageContent = (
      <p>
        Are you sure you want to download {pagination?.totalSize} Payout data
        ?<br />
      </p>
    );

    const params = {
      limit: pagination.limit,
      page: pagination.currentPage,
      ...(filters.search && {
        searchField: filters.searchField,
        search: filters.search,
      }),
      ...(filters.paymentProvider !== null && { paymentProvider: filters.paymentProvider }),
      ...(filters.isSuccess !== null && { isSuccess: filters.isSuccess }),
      ...(filters.status !== null && { status: filters.status }),
      ...(filters.payoutType !== null && { payoutType: filters.payoutType }),
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
    };

    Modal.confirm({
      content: messageContent,
      title: `Download Payout List ? `,
      async onOk() {
        await axios
          .get("api/payouts/csv", { params })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });

    setIsDownloading(false);
  };

  useEffect(() => {
    fetchPayouts();
  }, [pagination.currentPage, pagination.limit, fetchPayouts]);

  return (
    <div>
      <PageHeader
        title="Payout"
        childRoutes={[{ path: "/payout", breadcrumbName: "Payout" }]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <PayoutFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row className="mt-2 mb-2" justify="space-between">
        <div>
          <RemittanceButton selectedRowKeys={selectedRows} filters={filters} />
          <Button onClick={downloadCSV} loading={isDownloading}>
            CSV <DownloadOutlined />
          </Button>
        </div>
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>

      <PayoutList
        onSelectRows={(selectedRowKeys) => setSelectedRows(selectedRowKeys)}
        selectedRows={selectedRows}
        payouts={payouts}
        loading={loading.index}
      />

      <Pagination
        total={pagination?.totalSize}
        pageSize={pagination?.limit}
        onChange={(currentPage, limit) => {
          setPagination({ ...pagination, limit, currentPage });
        }}
        current={pagination.currentPage}
      />
    </div>
  );
};

export default Payout;
